"use client"

import { useEffect } from "react"
import HeroSection from "@/components/home/hero-section"
import TrustSection from "@/components/home/trust-section"
import FeaturedCourses from "@/components/home/featured-courses"
import QuizSection from "@/components/home/quiz-section"
import ResourcesSection from "@/components/home/resources-section"
import AchievementStats from "@/components/home/achievement-stats"
import ValuesSection from "@/components/home/values-section"
import SelectionBoard from "@/components/home/selection-board"
import CTASection from "@/components/home/cta-section"
import TestimonialsSection from "@/components/home/testimonials-section"
import StudentReviews from "@/components/home/student-reviews"
import FacultySection from "@/components/home/faculty-section"
import FounderSection from "@/components/home/founder-section"
import WhatsAppIcon from "@/components/home/whatsapp-icon"
import { usePortal } from "@/hooks/use-portal"
import { motion } from "framer-motion"

export default function HomePage() {
  const { portal, setPortal } = usePortal()

  // Ensure default is tspsc on first load
  useEffect(() => {
    if (!portal) setPortal('tspsc')
  }, [portal, setPortal])

  return (
    <motion.div
      className="bg-background min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <HeroSection />
      <AchievementStats />
      
      <div>
        <QuizSection />
        <FeaturedCourses />
        <ResourcesSection />
        <ValuesSection />
        <FacultySection />
        <StudentReviews />
        <TestimonialsSection />
        <CTASection />
        <FounderSection />
      </div>

      <WhatsAppIcon />
    </motion.div>
  )
}
